import type React from 'react'
import type { ReactNode } from 'react'

import { SpriteMap16 } from '../global'
import { createVariants } from '../lib'
import { Icon } from './Icon'

const buttonClasses = createVariants({
  base: 'w-full flex flex-col items-start gap-2 px-4 py-3 rounded-lg border-2 overflow-hidden cursor-pointer',
  variants: {
    active: {
      true: 'bg-accent-100 border-green',
      false: 'bg-white border-gray-300'
    },
    disabled: {
      true: 'opacity-50 cursor-not-allowed',
      false: ''
    }
  },
  compoundVariants: [
    { active: false, disabled: false, className: 'hover:bg-gray-50' },
    { active: false, disabled: true, className: 'hover:bg-white' }
  ]
})

const iconClasses = createVariants({
  base: 'size-6 shrink-0',
  variants: {
    active: { true: 'text-green' },
    disabled: { true: 'text-gray-400' }
  }
})

type OptionButtonProps = {
  onClick?: (() => void) | React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  title: string
  active: boolean
  description?: string
  IconElement: ({ className }: { className: string }) => ReactNode
}

export const OptionButton = ({
  IconElement,
  title,
  description,
  active,
  disabled,
  onClick
}: OptionButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses({ active, disabled: disabled ?? false })}
    >
      <div className="flex w-full items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <IconElement className={iconClasses({ active, disabled: disabled ?? false })} />
          <span className="pan-body-bold">{title}</span>
        </div>
        {active && (
          <Icon icon={SpriteMap16.CheckCircleFilled16} className="size-4 shrink-0 text-green" />
        )}
      </div>
      {description !== undefined && (
        <p className="pan-body-small w-full text-left text-gray-700">{description}</p>
      )}
    </button>
  )
}
